<template>
  <div>

    <template v-if="display==1">
      <h5>メルマガ管理</h5>
      <hr>

      <div class="z_inmax col-md-12 mt-1 mb-1 text-right">
          <span class="col-md-3 btn mb-3" style="background-color: hsla(0,0%,82%,0);border: dashed 1px darkcyan;color: darkcyan;">送信先選択:</span>
          <a class="btn btn-info col-md-3 mb-3" style="color: white;" href="javascript:void(0);" @click="dispChange(null, 1);">一般ユーザ</a>
          <a class="btn btn-info col-md-3 mb-3" style="color: white;" href="javascript:void(0);" @click="dispChange(null, 2);">販売者</a>
      </div>

      <div class="col-md-12 sp-form-container">
        <table class="table text-nowrap table-striped table-hover">
          <caption></caption>
          <thead class="" style="background: linear-gradient(to bottom, #f9f9f9 0%, #ececec 100%) !important;">
            <tr>
              <th scope="col">送信日時</th>
              <th scope="col">件名</th>
            </tr>
          </thead>
          <tbody>
            <template v-for="(send_mail, index) in allGetSendMails">
              <tr class="table-light" @click="dispChange(send_mail, send_mail['send_type']);">
                <td class="">{{ convert_jst_for_message(send_mail['created_at']) }}</td>
                <td class="">{{ send_mail['title'] }}</td>
              </tr>
            </template>
          </tbody>
        </table>

        <div class="page" v-show="allGetSendMails.length>0">
          <vuejs-paginate
            :page-count="allGetPageCount"
            :page-range="3"
            :margin-pages="2"
            :click-handler="allClickCallback"
            :prev-text="'＜'"
            :next-text="'＞'"
            :container-class="'pagination'"
            :page-class="'page-item'">
          </vuejs-paginate>
        </div>

      </div>
    </template>

    <template v-if="display==2">
      <h5>メール送信</h5>
      <a class="btn btn-info col-md-4" href="javascript:void(0);" @click="backSendMail">戻る</a>
      <hr>

      <div class="col-md-12 sp-form-container">

        <div id="counselors" class="counselors mt-3 pt-1" style="background-color: ivory;"> 

            <h4 style="background-color: #fbfcad;" class="m-3 p-3">
              <span v-if="String(sendForm.send_type) == '1'">一般ユーザ</span>
              <span v-if="String(sendForm.send_type) == '2'">販売者ユーザ</span>
              に一斉送信する
            </h4>

            <div class="form-group">
                <label class="col-sm-10 control-label">メール種別  <span class="required_mark">必須</span></label>
                <div class="col-sm-10">
                    <label class="checkbox-inline p-3">
                        <input type="radio" v-model="sendForm.type" value="1">
                        html形式
                    </label>
                    <label class="checkbox-inline p-3">
                        <input type="radio" v-model="sendForm.type" value="2">
                        テキスト形式
                    </label>
                </div>
            </div>

            <div class="form-group">
                <div class="col-sm-12">
                  <label class="control-label">メールタイトル  <span class="required_mark">必須</span></label>
                  <textarea  placeholder="" v-model="sendForm.title" class="required form-control" rows="1" maxlength="1000" v-bind:class="{ error_input: sendForm.errors.title.length > 0 }"></textarea>
                  <div v-if="sendForm.errors.title.length > 0">
                    <div class="error-text" v-for="(item, index) in sendForm.errors.title" :key="index">{{ item }}</div>
                  </div>
                </div>
            </div>

            <div class="form-group">
                <div class="col-sm-12">
                  <label class="control-label">メール本文  <span class="required_mark">必須</span></label>
                  <textarea  placeholder="" v-model="sendForm.contents" class="required form-control" rows="10" maxlength="5000" v-bind:class="{ error_input: sendForm.errors.contents.length > 0 }"></textarea>
                  <div v-if="sendForm.errors.contents.length > 0">
                    <div class="error-text" v-for="(item, index) in sendForm.errors.contents" :key="index">{{ item }}</div>
                  </div>
                </div>
            </div>

            <div class="form-group row">
                <div class="col-sm-6">
                </div>
                <div class="col-sm-6">
                    <a href="javascript:void(0)" @click="send_exec(true)" class="bs100 btn btn-danger">このメール内容をテスト送信する</a>
                </div>
            </div>

            <div class="form-group">
                <div class="col-sm-12 text-left">
                    <span>予定配信者数 </span>
                    <span v-if="String(sendForm.send_type) == '1'">{{ send_count_1 }}</span>
                    <span v-if="String(sendForm.send_type) == '2'">{{ send_count_2 }}</span>
                    <span>人</span>
                </div>
            </div>

            <div class="form-group">
                <div class="b100 col-sm-12">
                    <a href="javascript:void(0)" @click="send_exec(false)" class="bs100 btn btn-primary">一括送信する</a>
                </div>
            </div>

        </div>

      </div>
    </template>

  </div>
</template>

<script>
import VueJsPaginate from "vuejs-paginate";

export default {
  components: {
    'vuejs-paginate': VueJsPaginate,
  },
  props: { 
    user: Object
  },
  data() {
    return {
      display: 1,
			all_send_mails: [],
			all_parPage: 5,
			all_currentPage: 1,
      send_count_1: 0,
      send_count_2: 0,

      isError: false,
      sendForm: {
        title: "",
        contents: "",
        type: 1,
        send_type: "",
        errors: {
          title: [],
          contents: [],
          type: [],
          send_type: [],
        },
      },
    }
  },
  methods: {
    async sendMailExec(testFlg) {
      this.$store.dispatch('user/post_send_mail', {
        sendForm: this.sendForm,
        testFlg: testFlg,
      }).then(res => {
        // let order = res.data.orders;
        // console.log(order);
        alert('送信が完了しました');
      }, error => {
        // バックエンドからエラーが返却された場合、ひとまずアラートでメッセージを出力
        console.log(error.response.data);
        if ('error' in error.response.data) {
          alert(error.response.data['error']);
          window.scrollTo({
            top: 0,
          });
        }
      });
    },
    send_exec: function(testFlg) {
      this.isError = false;
      this.sendForm.errors.title = [];
      this.sendForm.errors.contents = [];
      if (!this.sendForm.title) {
        this.sendForm.errors.title.push('タイトルが入力されていません');
        this.isError = true;
      }
      if (!this.sendForm.contents) {
        this.sendForm.errors.contents.push('本文が入力されていません');
        this.isError = true;
      }
      if (this.isError) {
        window.scrollTo({
          top: 0,
        });
      } else {
        this.sendMailExec(testFlg);
        return false;
      }
      return false;
    },
    backSendMail: function() {
      this.display = 1;
      return false;
    },
    dispChange: function (send_mail, send_type) {
      this.sendForm.send_type = send_type;
      if ( send_mail != null ) { // 登録済みの値を反映
        this.sendForm.title = send_mail['title'];
        this.sendForm.contents = send_mail['contents'];
        this.sendForm.type = send_mail['type'];
      } else {
        this.sendForm.title = "";
        this.sendForm.contents = "";
        this.sendForm.type = 1;
      }
      this.display = 2;
      return false;
    },
		async get_send_mails() {
			this.$store.dispatch('user/get_send_mails', {
        // status: this.searchForm.status,
        // sort: this.searchForm.sort,
      }).then(res => {
				console.log(res);
				this.all_send_mails = res.data.send_mails;
        this.send_count_1 = res.data.send_count_1;
        this.send_count_2 = res.data.send_count_2;
				// this.articleCount = this.all_articles.length;
			}, error => {
				console.log('error発生');
				console.log(error);
				this.$nextTick(() => {
          window.scrollTo({
            top: 0,
          });
				});
			});
		},
		allClickCallback: function (pageNum) {
      this.all_currentPage = Number(pageNum);
			this.$nextTick(() => {
				window.scrollTo({
					top: 0,
				});
			});
    },
  },
	computed: {
		allGetSendMails: function() {
			let current = this.all_currentPage * this.all_parPage;
			let start = current - this.all_parPage;
			return this.all_send_mails.slice(start, current);
		},
		allGetPageCount: function() {
			return Math.ceil(this.all_send_mails.length / this.all_parPage);
		},
	},
  created() {
    this.get_send_mails();
  },
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/mypage/admin/mail.vue